import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Employee name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'phone',
    title: 'Telephone number',
    is_required: true,
    question_type: 'telephone',
  },
  {
    id: 'street_address',
    title: 'Street address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const completeFormInitialQuestion = [
  {
    id: 'is_exempt',
    title: 'Please select:',
    is_required: true,
    question_type: 'long_multiple_choice',
    options: [
      {
        codeValue: 'no_need',
        shortName: 'I don\'t need to complete Pennsylvania form REV-419.',
      },
      {
        codeValue: 'need_to_complete',
        shortName: 'I am entitled to non withholding of PA personal income tax and need to complete form REV-419.',
      },
    ],
  },
];

export const reciprocalStateOptions = [
  { codeValue: 'indiana', shortName: 'Indiana' },
  { codeValue: 'maryland', shortName: 'Maryland' },
  { codeValue: 'new_jersey', shortName: 'New Jersey' },
  { codeValue: 'ohio', shortName: 'Ohio' },
  { codeValue: 'virginia', shortName: 'Virginia' },
  { codeValue: 'west_virginia', shortName: 'West Virginia' },
];
